module.exports = __webpack_public_path__ + "images/img-3NwkwCs.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/en/preview.jpg
// module id = 2005
// module chunks = 0